import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { derAutoCreateVirbom_terkk_krov_children, derAutoCreateVirbom_terkk_krov_prepare_vir_input, _derivat_krov_izracunaj_naziv } from "./ter-derivat-lib-terkk-krov";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import { _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey } from "./ter-virbom-datarender";


// TER DRAFTEL CODECS LIB

/*
POSTOLJE

- bundle postolje se sastoji od profila postolja a samo postolje kao virtel necemo ni imati jer se ono pretvara u momentu kad se sastavlja u modul.

TODO:
- _bundle_klizac ne obuhvata vise postolja nego vise profila od kojih se sastoji jedno postolje




*/

/*
KROV je u sastavnici poput postolja ili panela tj. ne pojavljuje se u sastavnici kao jedan virtel krov nego se vise vritela koji su delovi krova (LIM-ovi) pojavljuju ravnopravno u sastavnici.
*/


export const draftel_codecs_pack_terkk$_bundle_krov = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$_bundle_krov.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_krov',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    _subform_arr: [], // SUBFORM ARR

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    // pods_input za bundle nepotreban jer se koristi widget za pods_input
    // siframodula: null,
    // msirinaspoljasnja: null,
    // duzinamodula: null,

    termaterijal: "LB00000J", // default materijal

    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_krov.default_pods_input_state = () => {
  /*
  return {
    siframodula: null,
    msirinaspoljasnja: null,
    duzinamodula: null
  };
  */
  return default_pods_input_state_smart_get('terkk$krov$child');
};


draftel_codecs_pack_terkk$_bundle_krov.default_subform_item_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$krov$child',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    // cncprogram1: '', // NOVO

    // od krov segmenta
    tipkrovnogsegmenta: null,
    // naziv: null,
    sirina: null,
    duzina: null,
    povrsina: -1, // da ne bi proslo validaciju po defaultu
    //
    krovniotvor: "NE",
    "a": null,
    "b": null,
    "x": null,
    "y": null,
    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_krov.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 
  // "vrstaprofila",
  // "msirinaspoljasnja",
  // "duzinamodula",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_krov.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_krov.default_subform_item_preset_state())
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$_bundle_krov.subDrafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima

};


draftel_codecs_pack_terkk$_bundle_krov.bundleDrafel_to_paired_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$krov');
  console.log(formState);
  let state = {
    ...formState
  };
  const p = state;
  // const krovNaziv = '? krov ?';
  // const krovNaziv = _derivat_krov_izracunaj_naziv(p.sirina, p.duzina, p.tip, p.krovniotvor, p.a, p.b);
  const krovNaziv = 'KROV U CELINI'; // TODO
  p.naziv = krovNaziv;
  //
  const _params = {
    // "operacija": "OPSKL",
    // "rc": "RCDE",
    // "operacija": "OPNISTA",
    "operacija": "OPSKUP",
    "rc": "RCNISTA",
    // tergrupa: 'krov',
  };
  const virtel = {
    ...p,
    virtelschemakey: 'terkk$krov',
    paired_with_smartel: true,
    ..._get_fixed_fields(sema),
    ..._params,
    ..._getParamsFromLib("terkk$krov") // parametri na kraju imaju prioritet
  };
  return virtel; // return virtel
};


/////////


draftel_codecs_pack_terkk$_bundle_krov.bundleDraftel_to_unbundled_subDraftel_arr = (bundleDraftel) => {
  // draftel single BUNDLE to draftel array
  const bundle = bundleDraftel;
  let _unbundled_subDraftel_arr = [];
  const zajednicki_higher_props_za_items = {
    // meta
    parent_subkey: bundle.parent_subkey,
    superkey: bundle.superkey,
    // bundle_id: p.bundle_id,
    // od poluproizvoda

    // pods_input TODO Da li treba bolje resenje?
    flag_custom_pods_input: bundle.flag_custom_pods_input,
  };
  if (Array.isArray(bundle._subform_arr)) {
    bundle._subform_arr.forEach(_sf_item_raw => {
      let subDraftel_krov = {
        ...draftel_codecs_pack_terkk$_bundle_krov.default_preset_state(),
        ..._sf_item_raw,
        ...zajednicki_higher_props_za_items
      };
      _unbundled_subDraftel_arr.push(subDraftel_krov);
    });
  };
  return _unbundled_subDraftel_arr;
};


draftel_codecs_pack_terkk$_bundle_krov.bundleDrafel_to_virbom = (bundleDraftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$krov');

  // let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);

  // paired_virtel nece biti ukljucen u virbom ali ga ipak kreiramo kako bi od njega dobili vir_input za childrene
  const paired_virtel = draftel_codecs_pack_terkk$_bundle_krov.bundleDrafel_to_paired_virtel(bundleDraftel);

  const local_graphlevel = 1;
  // _virbom_manipulator.add_as_first_virtel(virbom_ref, paired_virtel);

  // KORAK DODAVANJE CHILDRENA OD paired_virtel-a

  const _unbundled_subDraftel_arr = draftel_codecs_pack_terkk$_bundle_krov.bundleDraftel_to_unbundled_subDraftel_arr(bundleDraftel);

  let pods_input_za_derivate = derAutoCreateVirbom_terkk_krov_prepare_vir_input(paired_virtel); // ??? 
  let _der_virtel_children = derAutoCreateVirbom_terkk_krov_children(pods_input_za_derivate, _unbundled_subDraftel_arr);
  console.log('_der_virtel_children krov', _der_virtel_children);
  let _der_virtel_children_2 = _der_virtel_children.map((_virtel) => {
    // posot sada ne krov parent elementa i nemamo merge, sada moramo rucno da im dodamo subkey-eve...
    return _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey(_virtel);
  });
  // USISAVANJE
  // _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _der_virtel_children, local_graphlevel, virbomCounter.generateFreshSubkey);

  // ZAVRSENI KORACI ZA JEDAN pp3
  // ***ZAVRSENI KORACI ZA JEDAN pp3

  // ZAVRSENI KORACI ZA JEDAN pp3

  // const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  // const virbom_seq = _der_virtel_children;
  const virbom_seq = _der_virtel_children_2;
  return virbom_seq; // return virbom
};


// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------
// ZA NOVE POLUPROIZVODE NECEMO NI KORISTITI DECODING


/*
draftel_codecs_pack_terkk$_bundle_krov.virtel_to_subDraftel = (virtel) => {
  // pretvara iz virtela u formState format
  //
  let state = {
    ...draftel_codecs_pack_terkk$_bundle_krov.default_subform_item_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel, draftel_codecs_pack_terkk$_bundle_krov.keys_for_direct_cloning)
  };
  //
  return state;
};
*/

